import { AWS_ALL_REGION_CODES, AWS_SELECT_ALL_REGIONS_VALUE } from '../constants/awsRegions';

export type AwsFormDetails = {
  accountId: string;
  region: string;
  accessKeyId: string;
  secretAccessKey: string;
  vpcId: string;
  iamRole: string;
};

export function normalizeAwsDetailsForApi(aws: AwsFormDetails) {
  const accountId = (aws.accountId ?? '').trim();
  const accessKeyId = (aws.accessKeyId ?? '').trim();
  const secretAccessKey = (aws.secretAccessKey ?? '').trim();
  const vpcId = (aws.vpcId ?? '').trim();
  const iamRole = (aws.iamRole ?? '').trim();

  if (aws.region === AWS_SELECT_ALL_REGIONS_VALUE) {
    return {
      accountId,
      accessKeyId,
      secretAccessKey,
      region: '',
      regions: [...AWS_ALL_REGION_CODES],
      allRegions: true,
      ...(vpcId ? { vpcId } : {}),
      ...(iamRole ? { iamRole } : {})
    };
  }

  return {
    accountId,
    accessKeyId,
    secretAccessKey,
    region: (aws.region ?? '').trim(),
    ...(vpcId ? { vpcId } : {}),
    ...(iamRole ? { iamRole } : {})
  };
}
